import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Skeleton from '@material-ui/lab/Skeleton';
import { propArrayShape, propBool, propFunc, propShape, propStr, } from '../../../../../../../helpers/custom-prop-types';
import UploadHistoryTableHead from './UploadHistoryTableHead';
import UploadHistoryTableRow from './UploadHistoryTableRow';
const UploadHistoryTable = (props) => {
    const { loading, onSubmitBlock, rows, searchText, updateMap } = props;
    if (loading) {
        return (_jsxs("table", Object.assign({ className: 'mypage_slide_table' }, { children: [_jsx(UploadHistoryTableHead, {}), _jsx("tbody", { children: _jsxs("tr", Object.assign({ className: 'row' }, { children: [_jsx("td", Object.assign({ className: 'col' }, { children: _jsx(Skeleton, { className: 'skeleton', variant: 'rect' }) })), _jsx("td", Object.assign({ className: 'col' }, { children: _jsx(Skeleton, { className: 'skeleton', variant: 'rect' }) })), _jsx("td", Object.assign({ className: 'col' }, { children: _jsx(Skeleton, { className: 'skeleton', variant: 'rect' }) }))] })) })] })));
    }
    return (_jsxs("table", Object.assign({ className: 'mypage_slide_table' }, { children: [_jsx(UploadHistoryTableHead, {}), _jsx("tbody", { children: rows.length > 0 ? (rows.map((row) => (_jsx(UploadHistoryTableRow, { item: row, onSubmitBlock: onSubmitBlock, updateMap: updateMap }, row.id)))) : (_jsx("tr", Object.assign({ className: 'data_row row' }, { children: _jsx("td", Object.assign({ className: 'col empty_col', colSpan: 4 }, { children: searchText
                            ? '該当する検索結果がありません'
                            : 'アップロード履歴はまだありません' })) }))) })] })));
};
UploadHistoryTable.propTypes = {
    loading: propBool().isRequired,
    onSubmitBlock: propFunc().isRequired,
    rows: propArrayShape(),
    searchText: propStr(),
    updateMap: propShape().isRequired,
};
UploadHistoryTable.defaultProps = {
    rows: [],
    searchText: '',
};
export default UploadHistoryTable;
